<div class="relative z-header h-60">
  <header class="z-fg fixed top-0 left-0 right-0 top-0">
    <div class="bg-gray-light px-16">
      <div class="h-60 flex items-center">
        <a
          [routerLink]="['/']"
          href="/"
          class="inline-block w-60"
        >
          <app-logo></app-logo>
        </a>
        <div class="ml-auto">
          <div class="hidden lg:block">
            <app-nav [links]="links"></app-nav>
          </div>
          <div class="lg:hidden">
            <app-hamburger-menu (clickEmitter)="handleHamburgerButtonClick()"></app-hamburger-menu>
          </div>
        </div>
      </div>
    </div>
    <div class="z-fg absolute left-0 right-0">
      <app-nav-mobile
        [isActive]="navbarOpen"
        [links]="links"
      >
      </app-nav-mobile>
    </div>
  </header>
  <ng-container *ngIf="navbarOpen">
    <div class="bg-gray-dark fixed inset-0 z-bg"></div>
  </ng-container>
</div>
